import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import close from "../../../../assets/close.svg";
import { SetActiveDriverList, SetSelectedMonitoringDriver, SetSelectedMonitoringOrder, Set_OrderList_OrderTypes } from "../../../../Redux/actions/actionNames";
import OrderlistMapper from "./OrderlistMapper";
import DriverInfoMaper from "./DriverInfoMaper";
import deliveryProfile from "../../../../assets/delivery-man.png";
import iccall from "../../../../assets/ic-call.svg";
import { Voip_OutgoingCall } from "../../../../Redux/actions/actions";
import { get_id } from "../../../../helper/UserData/userdate";
import { getOrderMonitoringBounding } from "./drivers-list/getOrderMonitoring";
import { ARROW_LEFT, CALL, COPY, Dcall, Dcar, Demail, Dvehicle, INFO_CIRCLE, Phubd_deactive, Routes_active, adsigne, arrowLeftBold, arrowTop, box_gray, phubd_active } from "../../../../assets";
import Button from "../../../../design-system/lib/Button";
import styles from './driverinfo.module.css';
import clsx from "clsx";
import Typography from "../../../../design-system/lib/Typography";
import ProgressIndicator from "../../../../design-system/lib/ProgressIndicator";
import { fontSize, width } from "@mui/system";
import history from "../../../../service/history";
import { ClickAwayListener, Tooltip, TooltipProps, tooltipClasses } from 'newmaterial-ui';
import { styled } from 'newmaterial-ui/styles';
import { isEmpty } from 'lodash';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { snack } from "../../../../utils/SnackbarUtilsConfigurator";
 

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip  {...props} classes={{ popper: className }} />
))(({ theme }) => ({
      [`&.${tooltipClasses.popper}`]: {
    marginLeft: '-11px !important', // 👈 فاصله از سمت راست
  },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: ' #fff',
        borderRadius: "8px",
        padding: "8px",
        border: 'none',
        boxShadow: "0 4px 12px 0 rgba(0, 0, 0, 0.24)",
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: "auto",
        fontSize: theme.typography.pxToRem(12),
        marginBottom: "0px !important",
        height: "auto" 
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "white",
        marginInlineStart:"12px"
    },
}));

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 1,
      infoOpen : false
    };
  }
  handledriver = () => {
    this.props.dispatch(SetActiveDriverList(null));
    this.props.dispatch(SetSelectedMonitoringDriver(null))
    this.props.dispatch(SetSelectedMonitoringOrder(null))

  };
  handleTab = (num) => {
    this.setState({
      active: num,
    });
    this.handleGetOrders()
  };

  handleGetOrders() {

  }

  makeOutgoingCall = (event) => {
      event.stopPropagation();
    this.props.dispatch(Voip_OutgoingCall(this.props.dispatch, {
      "to": this.props.activeDriver.phone,
      "orderId": null,
      "customerId": null,
      "driverId": this.props.activeDriver.id,
      "dispatcherId": get_id()
    }))
  }

  ToArray = () => {
    return Object.keys(this.props.OrderList).map(
      (id) => this.props.OrderList[id]
    );
  };


  render() {
    return (
      <div className="driverItemInfo" style={{ backgroundColor: "rgba(244, 244, 247, 1)", position: "absolute", top: "0", bottom: "0", border: "0" }}>
        <div className={styles.container} onClick={()=>{
           this.setState({
                          infoOpen: false
                        })
        }} >
            <ClickAwayListener onClickAway={() => {
    
              this.setState({
                          infoOpen: false
                        })
        }}>
          <div className={styles.containerf1} >      <Button size="Medium" type="Secondary" icon={arrowLeftBold} onClick={this.handledriver} className={styles.custombackbtn}  />
            <img src={this.props.activeDriver.avatarPhoto} className={clsx(styles.avatar, (this.props.activeDriver.ordersCount > 0 && this.props.activeDriver.isOnline) && styles.withOrder, (this.props.activeDriver.ordersCount == 0 && this.props.activeDriver.isOnline) && styles.noOrder)} onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = deliveryProfile;
            }} />
            <div className={styles.namephone}>
              <Typography weight="Body_Small_Medium" text={this.props.activeDriver.name} textColor="TextDark" />
              <Typography weight="Body_Small_Regular" className={styles.orders} text={<> <img style={{ width: "14px", height: "14px" }} src={adsigne} />{this.props.driverInfo?.username} {/* {ordersCount} {t("Orders")} */}

                <span style={{ height: "16px", width: "1px", backgroundColor: "rgba(128, 128, 128, 0.2)", margin: "0px 4px" }} />

                <img style={{ width: "14px", height: "14px" }} src={box_gray} />{this.props.driverInfo?.activeOrdersCount} {/* {ordersCount} {t("Orders")} */}</>} textColor="TextLight" style={{ direction: "ltr" }} />
            </div>
         {!global.config.dispatcherSettings.isVoipActvie && <a onClick={(e) => { }}  href={`tel:${this.props.driverInfo?.phone}`} style={{marginInlineEnd:"auto"}}><img src={CALL}  className={styles.HoverBtn} /></a>}

            {global.config.dispatcherSettings.isVoipActvie && <img onClick={this.makeOutgoingCall} src={CALL}  className={styles.HoverBtn}  style={{marginInlineEnd:"auto"}} />}

             <HtmlTooltip open={this.state.infoOpen} arrow title={
                <div className={styles.popUpContainer} onClick={(e) => {  }} >
                    <div className={styles.popUpItemContainer}>
                        <img src={Dcall} />
                        <span style={{fontSize: "13px" , fontWeight:"400" , color:"rgba(36, 36, 36, 1)" ,marginInlineEnd:"4px"}}  > {this.props.driverInfo?.phone}</span>
                           <CopyToClipboard text={this.props.driverInfo?.phone}
                        onCopy={() => snack.success(this.props.t("Saved"))}>
                       <img src={COPY} style={{marginInlineStart:"auto" , cursor:"pointer"}} />
                        </CopyToClipboard>
                    </div>
                   {!isEmpty(this.props.driverInfo?.email)  &&  <div className={styles.popUpItemContainer}>
                        <img src={Demail} />
                        <span style={{fontSize: "13px" , fontWeight:"400" , color:"rgba(36, 36, 36, 1)" ,marginInlineEnd:"4px"}}  > {this.props.driverInfo?.email}</span>
                                 <CopyToClipboard text={this.props.driverInfo?.email}
                        onCopy={() => snack.success(this.props.t("Saved"))}>
                       <img src={COPY} style={{marginInlineStart:"auto" , cursor:"pointer"}} />
                        </CopyToClipboard>
                    </div>}

                  <div className={styles.popUpItemContainer}>
                        <img src={Dcar} />
                        <span style={{fontSize: "13px" , fontWeight:"400" , color:"rgba(36, 36, 36, 1)" ,marginInlineEnd:"auto" , display:"flex" , flexDirection:"row" , justifyContent:"center" , alignItems:"center"}}  > {this.props.driverInfo?.vehicle?.plate}  <span style={{height:"16px",width:"1px" ,backgroundColor:"rgba(128, 128, 128, 0.2)" , margin:"0px 4px"}} /> {this.props.driverInfo?.vehicle?.color+" "+this.props.driverInfo?.vehicle?.model}</span>
                     </div>
  <div className={styles.popUpItemContainer}>
                        <img src={Dvehicle} style={{alignSelf:"start"}} />
                        <span style={{fontSize: "13px" , fontWeight:"400" , color:"rgba(36, 36, 36, 1)" ,marginInlineEnd:"auto" , display:"flex" , flexDirection:"row" , justifyContent:"center" , alignItems:"center"}}  > {this.props.driverInfo?.vehicleTypes.map(item => item.title).join(", ")}</span>
                     </div>

                      
                </div>
            } placement="top" onOpen={() => {  }} onClose={() => {   }} >
                          <img src={INFO_CIRCLE} className={styles.HoverBtn} onClick={(e) => {
                        e.stopPropagation();
                        let dwsds = !this.state.infoOpen
                         this.setState({
                          infoOpen: dwsds
                        })
                     
                    }} />
 
            </HtmlTooltip>
            
          </div>
</ClickAwayListener>
          {this.props.driverInfo?.isShowingRouteTabActive && <div className={styles.containerf2} >
            <Button size="Medium" onClick={() => { this.props.dispatch(Set_OrderList_OrderTypes("PickupDelivery")); history.push(`/PickupDelivery?driverusername=${this.props.driverInfo?.username}`) }} type="Secondary" icon={phubd_active} style={{ marginInlineEnd: "auto" ,fontSize:"13px" }} text={this.props.t("P_HUB_D Orders")} />
            <Button size="Medium" onClick={() => { history.push(`/routes?driverid=${this.props.driverInfo.id}`) }} type="Secondary" icon={Routes_active} style={{ marginInlineEnd: "auto"  ,fontSize:"13px"}} text={this.props.t("Routes")} />
          </div>}

          {/* <div style={{ height: "6px", width: "calc(100% + 32px)", marginLeft: "-4px", backgroundColor: "rgba(244, 244, 247, 1)" }} /> */}

              
          {/* <div className="switchDriverInfo"  style={{width:"calc(100% + 32px)"}}>
            <span className={`tab ${this.state.active === 1 && "tabActive"} ${this.state.active === 1 && styles.tabActive}`}  onClick={() => { this.handleTab(1) }}>
              {" "}
              {this.props.OrderListLoading && <ProgressIndicator theme="On_Light" style={{width:"16px",height:"14px"}} />}  <Trans i18nKey={"Ondemand"}> </Trans> {!this.props.OrderListLoading && <span className={styles.tag}>{this.ToArray().filter((arrx)=> arrx.driver != null).length}</span> } 
            </span>
            <span className={`tab ${this.state.active === 2 && "tabActive"} ${this.state.active === 2 && styles.tabActive}`} onClick={() => { this.handleTab(2) }}>
              {" "}
              <Trans i18nKey={"Info"}> </Trans>{" "}
            </span>
          </div> */}

        </div>
        {this.state.active === 1 ? <OrderlistMapper /> : <DriverInfoMaper />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  open: state.DriversList.open,
  EditOrderopen: state.EditOrder.OpenDialoge,
  NewOrderopen: state.NewOrder.OpenDialoge,
  ViewTravelopen: state.ViewTravel.OpenDialoge,
  list: state.DriversList.list,
  activeDriver: state.DriversList.activeDriver,
  OrderList: state.DriversList.OrderList,
  OrderListLoading: state.DriversList.OrderListLoading,
  OrderListOrdered: state.DriversList.OrderListOrdered,
  driverInfo: state.DriversList.driverInfo,

});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
